export const onlyTenDigitsPattern = /\b\d{10}\b/;
export const replaceToNumbers = /[ _()-]/g;
